// Probes assets/cameras/ for cam_1.png, cam_2.png, … (stops on first miss)
// then randomly fills the 4 feed slots each time the window opens,
// and rotates them every CONFIG.CAM_ROTATE_MS while the window is visible.

const _DIR = 'assets/cameras/';
let _pool = [];
let _timer = null;

function _probe(n, done) {
    if (n > 50) { done(); return; }
    const img = new Image();
    img.onload  = () => { _pool.push(`${_DIR}cam_${n}.png`); _probe(n + 1, done); };
    img.onerror = () => done();
    img.src = `${_DIR}cam_${n}.png?_=${Date.now()}`;
}

function _shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

function _assignFeeds() {
    if (!_pool.length) return;
    const shuffled = _shuffle(_pool);
    document.querySelectorAll('#w-cam .cam-feed img').forEach((img, i) => {
        img.src = shuffled[i % shuffled.length];
    });
}

const _fname = src => src.split('/').pop().split('?')[0];

function _tick() {
    const win = document.getElementById('w-cam');
    if (!win || win.style.display === 'none') {
        clearInterval(_timer);
        _timer = null;
        return;
    }
    if (_pool.length < 2) return;

    const feeds = [...document.querySelectorAll('#w-cam .cam-feed img')];
    const shown = new Set(feeds.map(img => _fname(img.src)));
    const candidates = _pool.filter(src => !shown.has(_fname(src)));
    if (!candidates.length) return;

    const idx = Math.floor(Math.random() * feeds.length);
    feeds[idx].src = candidates[Math.floor(Math.random() * candidates.length)];
}

function randomizeCameras() {
    _assignFeeds();
    if (_timer) clearInterval(_timer);
    _timer = setInterval(_tick, window.CONFIG.CAM_ROTATE_MS);
    if (window.triggerMission) window.triggerMission('cameras_open');
}

_probe(1, () => _assignFeeds());

window.randomizeCameras = randomizeCameras;
